import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { BANKRUPTCY_EVENT_TABS } from "src/constants/tabs";
import { useBankruptcyEventQuery } from "src/store/bankruptcyEvent";

export function BankruptcyEvent() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const {
    data: bankruptcyEvent,
    isLoading,
    error,
  } = useBankruptcyEventQuery({ id });
  const match = useMatch(`/bankruptcy-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/bankruptcy-events/${id}/${value}`);
  };

  if (error || (!isLoading && !bankruptcyEvent)) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Bankruptcy Events"
        to={`/bankruptcy-events?view=${
          bankruptcyEvent?.operationsStatus === "approved"
            ? "approved"
            : "upcoming"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/bankruptcy-events/${id}/details`}
          issuerName={bankruptcyEvent.issuer.name || "-"}
          issuerId={bankruptcyEvent.issuer?.id}
          type="Bankruptcy"
          subHeader={
            bankruptcyEvent.jobNumber
              ? `${bankruptcyEvent.claimsAdministrator.name} - ${bankruptcyEvent.jobNumber}`
              : bankruptcyEvent.claimsAdministrator.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={BANKRUPTCY_EVENT_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
